import store from "../store";
import  * as Actions from '../constants/XookConstants';

var defaultPrompt:any;

class PWAUtil {

    static setupPWAEventListeners() {
        
        window.addEventListener('beforeinstallprompt', (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            defaultPrompt = e;
            store.dispatch({ type: Actions.STORE_XOOK_DATA, data: { canInstallPWA: true } });
        });

        window.addEventListener('appinstalled', (e) => {
            e.preventDefault();
            defaultPrompt = null;
            store.dispatch({ type: Actions.STORE_XOOK_DATA, data: { canInstallPWA: false } });
        });

    }

    static async installPWA() {
        if(!defaultPrompt) return;
        defaultPrompt.userChoice
        .then((choiceResult:any) => {
            if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the install prompt');
            } else {
                console.log('User dismissed the install prompt');
            }
            defaultPrompt = null;
        });

        defaultPrompt.prompt();
    }

}

export default PWAUtil;